module.exports = __webpack_public_path__ + "static/media/1.221e8791.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/faster/1.mp3
// module id = 192
// module chunks = 0